export default "__VITE_ASSET__CSeyz7QA__"